export const extractPaginationData = (info) => ({
  page: info.current_page,
  perPage: info.per_page,
  lastPage: info.last_page,
  total: info.total,
  from: info.from || 0,
  to: info.to || 0,
  links: info.links,
});